import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastProvider } from './Toast';
import { ThemeProvider } from './Theme';

const PortalLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const isFlowBuilderRoute = location.pathname.includes('/flowbuilder');

  return (
    <ThemeProvider>
      <ToastProvider>
        <Header />
        <div className={`portal-layout pt-16 flex bg-neutral-950 text-white min-h-screen transition-[padding-left] duration-200 ${collapsed ? 'pl-20' : 'pl-56'}`}>
          <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
          <main
            className={
              isFlowBuilderRoute
                ? 'flex-1 flex flex-col min-h-0 h-[calc(100vh-4rem)] overflow-hidden p-0'
                : 'flex-1 min-w-0 p-6 overflow-auto min-h-[calc(100vh-4rem)]'
            }
          >
            <div
              className={
                isFlowBuilderRoute
                  ? 'flex flex-1 flex-col min-h-0 w-full overflow-hidden'
                  : 'portal-content w-full min-w-0 max-w-none overflow-x-auto'
              }
            >
              <Outlet />
            </div>
          </main>
        </div>
      </ToastProvider>
    </ThemeProvider>
  );
};

export default PortalLayout;
